export const EXECUTIVE_PERSON_TYPES = {
  LOCAL_EXECUTIVE: 'local_executive',
  FEDERAL_EXECUTIVE: 'federal_executive',
  STATE_EXECUTIVE: 'state_executive',
  STATE_AGENCY_STAFFER: 'state_agency_staffer',
};

export const EXECUTIVE_PERSON = 'executive_person';
